import { STEPS } from "@/mocks/ecfMocks";

export default function HowItWorks() {
  return (
    <section className="bg-slate-950 py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-14">
          <span className="inline-flex items-center px-3 py-1 rounded-full border border-slate-700 text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">
            Cómo funciona
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white max-w-lg">
            De JSON a{" "}
            <span className="text-emerald-400">AceptadoDGII</span>{" "}
            en 5 pasos
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {STEPS.map((step, i) => (
            <div key={step.num} className="relative">
              {/* Connector line */}
              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-px bg-gradient-to-r from-slate-700 to-transparent z-10" />
              )}

              <div className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden hover:border-blue-700/40 transition-colors group">
                {/* Number area */}
                <div className="p-6 pb-4">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-3xl font-black text-blue-800/40 group-hover:text-blue-700/60 transition-colors">
                      {step.num}
                    </span>
                    <div className="w-9 h-9 flex items-center justify-center bg-slate-800 rounded-xl">
                      <step.icon className="text-lg text-slate-400 group-hover:text-blue-400 transition-colors" />
                    </div>
                  </div>
                  <h3 className="font-bold text-white text-sm leading-tight mb-2">{step.title}</h3>
                  <p className="text-xs text-slate-400 leading-relaxed">{step.desc}</p>
                </div>

                {/* Bottom accent */}
                <div className="h-1 bg-gradient-to-r from-blue-800/0 via-blue-700/40 to-blue-800/0 group-hover:via-blue-600/70 transition-colors" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}